import React from "react";
import styled from "styled-components";


export default styled.span`
    text-decoration: underline;
`;
